import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiResponse } from '../models/api-response.model';
import {
  NotificacionConfiguracionDto,
  UpdateConfigRequest,
} from '../models/notificacion-configuracion.model';
import { AuthService } from './auth.service';
import { BaseApiService } from './api-base.service';
import { ConfigService } from './config.service';
import { ConfigClientService } from './configClient.service';
import { SINERGIAL_ROUTES } from '../constants/api-sinergial-routes';

const DEFAULT_PARAMS = {
  orden: 9,
} as const;

@Injectable({ providedIn: 'root' })
export class NotificacionConfiguracionService extends BaseApiService<
  ApiResponse<NotificacionConfiguracionDto[]>
> {
  private readonly auth: AuthService;

  constructor(
    http: HttpClient,
    configService: ConfigService,
    authService: AuthService,
    configClientService: ConfigClientService,
  ) {
    super(http, configService, configClientService, authService);
    this.auth = authService;
  }

  update(
    id: number,
    data: Partial<UpdateConfigRequest>,
  ): Observable<ApiResponse<NotificacionConfiguracionDto>> {
    return this.put<ApiResponse<NotificacionConfiguracionDto>>(
      `${SINERGIAL_ROUTES.NOTIFICACION_CONFIGURACION.PATH_BASE}/${id}`,
      data,
    );
  }

  getConfiguraciones(
    extra?: Record<string, string | number | boolean>,
  ): Observable<ApiResponse<NotificacionConfiguracionDto[]>> {
    const empresaId = this.auth.user()?.idEmpresa;
    const params: Record<string, string | number | boolean> = { ...DEFAULT_PARAMS, ...extra };
    if (empresaId != null) {
      params['IdsEmpresas'] = empresaId;
    }
    return this.get<ApiResponse<NotificacionConfiguracionDto[]>>(
      SINERGIAL_ROUTES.NOTIFICACION_CONFIGURACION.PATH_BASE,
      { params },
    );
  }
}
